D.console = {
	info:function(){
		if( typeof console == 'object' && typeof console.info == 'function' ){
			try{
				console.info.apply( console, arguments );
			} catch(e){
			}
		}
	},
	error:function(err){
		if( typeof console == 'object' && typeof console.error == 'function' ){
			console.error.apply( console, arguments );
		}
		if( err instanceof Error && window.onerror ){
			window.onerror( err.name + ': ' + err.message, err, err.fileName || '', err.lineNumber || 0, 0, err );
		}
	},
	warn:function(){
		if( typeof console == 'object' && typeof console.warn == 'function' ){
			console.warn.apply( console, arguments );
		}
	},
	debug:function(){
		if( typeof console == 'object' && typeof console.debug == 'function' ){
			console.debug.apply( console, arguments );
		}
	},
	log:function(){
		if( typeof console == 'object' && typeof console.log == 'function' ){
			console.log.apply( console, arguments );
		}
	}
};

D.log = function(){
	D.console.info.apply( D.console, arguments );
};
